import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "clearBtn", "section", "item", "noResults"]

  // Turbo Stream で行やツリーが差し替わったあとも、検索中ならフィルタを当て直す
  // （差し替わった行はインラインの display:none を持っていないため）
  itemTargetConnected() {
    this.refilterIfSearching()
  }

  sectionTargetConnected() {
    this.refilterIfSearching()
  }

  refilterIfSearching() {
    if (!this.hasInputTarget || !this.inputTarget.value.trim()) return
    if (this._refilterQueued) return
    this._refilterQueued = true
    // 同時に何行も接続されるので、1フレームにまとめて1回だけ実行
    requestAnimationFrame(() => {
      this._refilterQueued = false
      this.filter()
    })
  }

  filter() {
    const query = this.inputTarget.value.trim().toLowerCase()

    if (query) {
      this.clearBtnTarget.classList.remove("hidden")
    } else {
      this.clearBtnTarget.classList.add("hidden")
    }

    // 検索中は閉じているカテゴリの中身も見せる（CSSの .is-searching で hidden を打ち消す）
    this.element.classList.toggle("is-searching", !!query)

    let totalVisible = 0

    this.sectionTargets.forEach(section => {
      const items = this.itemTargets.filter(item => section.contains(item))
      let sectionVisible = 0

      items.forEach(item => {
        const name = (item.dataset.itemName || "").toLowerCase()
        const match = !query || name.includes(query)
        item.style.display = match ? "" : "none"
        if (match) sectionVisible++
      })

      section.style.display = sectionVisible > 0 ? "" : "none"
      totalVisible += sectionVisible
    })

    // 検索中はドラッグハンドルを非表示にして並び替え無効化
    this.element.querySelectorAll(".drag-handle").forEach(handle => {
      handle.style.display = query ? "none" : ""
    })

    if (this.hasNoResultsTarget) {
      this.noResultsTarget.classList.toggle("hidden", totalVisible > 0 || !query)
    }
  }

  clear() {
    this.inputTarget.value = ""
    this.filter()
    this.inputTarget.focus()
  }
}
